import { createAction, props } from '@ngrx/store';

import { createFailure, createSuccess } from '../utils/action-utils';
import {
  IAssetList,
  IExposureMonitoring,
  IScanConfig,
  IScanConfigNetworkAsset,
  IScanConfigNetworkOverview,
  IScanConfigWebAppCreate,
  IScanConfigWebAppOverview,
} from './models/scan-configuration';

// Get Scan Config Actions //
const getScanConfigKey = '[Scan Configuration] Get Scan Config';
export const getScanConfig = createAction(getScanConfigKey);
export const getScanConfigSuccess = createAction(
  createSuccess(getScanConfigKey),
  props<{ res: IScanConfig }>(),
);
export const getScanConfigFailure = createAction(
  createFailure(getScanConfigKey),
  props<{ error: any }>(),
);

// Get Web App Actions //
const getWebAppKey = '[Scan Configuration] Get Web App';
export const getWebApp = createAction(getWebAppKey, props<{ id: string }>());
export const getWebAppSuccess = createAction(
  createSuccess(getWebAppKey),
  props<{ res: IScanConfigWebAppOverview }>(),
);
export const getWebAppFailure = createAction(
  createFailure(getWebAppKey),
  props<{ error: any }>(),
);

// Get Network Actions //
const getNetworkKey = '[Scan Configuration] Get Network';
export const getNetwork = createAction(getNetworkKey);
export const getNetworkSuccess = createAction(
  createSuccess(getNetworkKey),
  props<{ res: IScanConfigNetworkOverview[] }>(),
);
export const getNetworkFailure = createAction(
  createFailure(getNetworkKey),
  props<{ error: any }>(),
);

// Edit network assets actions //
const editNetworkAssetsKey = '[Scan Configuration] Edit Network Assets';
export const editNetworkAssets = createAction(
  editNetworkAssetsKey,
  props<{ hosts: { ipAddress: string; enabled: boolean }[] }>(),
);
export const editNetworkAssetsSuccess = createAction(
  createSuccess(editNetworkAssetsKey),
);
export const editNetworkAssetsFailure = createAction(
  createFailure(editNetworkAssetsKey),
  props<{ error: any }>(),
);

// Create Web App Actions //
const createWebAppKey = '[Scan Configuration] Create Web App';
export const createWebApp = createAction(
  createWebAppKey,
  props<{ data: IScanConfigWebAppCreate }>(),
);
export const createWebAppSuccess = createAction(
  createSuccess(createWebAppKey),
  props<{ data: IScanConfigWebAppCreate }>(),
);
export const createWebAppFailure = createAction(
  createFailure(createWebAppKey),
  props<{ error: any }>(),
);

// Get Network Assets Actions //
const getNetworkAssetsKey = '[Scan Configuration] Get Network Assets';
export const getNetworkAssets = createAction(getNetworkAssetsKey);
export const getNetworkAssetsSuccess = createAction(
  createSuccess(getNetworkAssetsKey),
  props<{ res: IScanConfigNetworkAsset[] }>(),
);
export const getNetworkAssetsFailure = createAction(
  createFailure(getNetworkAssetsKey),
  props<{ error: any }>(),
);

// Create Network Actions //
const createNetworkKey = '[Scan Configuration] Create Network';
export const createNetwork = createAction(
  createNetworkKey,
  props<{ assetIds: string[] }>(),
);
export const createNetworkSuccess = createAction(
  createSuccess(createNetworkKey),
);
export const createNetworkFailure = createAction(
  createFailure(createNetworkKey),
  props<{ error: any }>(),
);

// Update Network Actions //
const updateNetworkKey = '[Scan Configuration] Update Network';
export const updateNetwork = createAction(
  updateNetworkKey,
  props<{ id: string; assetIds: string[] }>(),
);
export const updateNetworkSuccess = createAction(
  createSuccess(updateNetworkKey),
);
export const updateNetworkFailure = createAction(
  createFailure(updateNetworkKey),
  props<{ error: any }>(),
);

// Remove Config Actions //
const removeConfigKey = '[Scan Configuration] Remove Config';
export const removeConfig = createAction(
  removeConfigKey,
  props<{ id: string }>(),
);
export const removeConfigSuccess = createAction(createSuccess(removeConfigKey));
export const removeConfigFailure = createAction(
  createFailure(removeConfigKey),
  props<{ error: any }>(),
);

// Get Assets List Actions //
const getAssetListKey = '[Scan Configuration] Get Asset List';
export const getAssetList = createAction(getAssetListKey);
export const getAssetListSuccess = createAction(
  createSuccess(getAssetListKey),
  props<{ assetList: IAssetList[] }>(),
);
export const getAssetListFailure = createAction(
  createFailure(getAssetListKey),
  props<{ error: any }>(),
);

// Get Exposure Monitoring Actions //
const getExposureMonitoringKey = '[Scan Configuration] Get Exposure Monitoring';
export const getExposureMonitoring = createAction(getExposureMonitoringKey);
export const getExposureMonitoringSuccess = createAction(
  createSuccess(getExposureMonitoringKey),
  props<{ res: IExposureMonitoring }>(),
);
export const getExposureMonitoringFailure = createAction(
  createFailure(getExposureMonitoringKey),
  props<{ error: any }>(),
);

// Save Exposure Monitoring Actions — the modal's diff: ids to start monitoring and ids
// to stop. Applied as two API calls, unmonitor first so the plan headroom is freed.
const saveExposureMonitoringKey =
  '[Scan Configuration] Save Exposure Monitoring';
export const saveExposureMonitoring = createAction(
  saveExposureMonitoringKey,
  props<{ monitor: string[]; unmonitor: string[] }>(),
);
export const saveExposureMonitoringSuccess = createAction(
  createSuccess(saveExposureMonitoringKey),
);
export const saveExposureMonitoringFailure = createAction(
  createFailure(saveExposureMonitoringKey),
  props<{ error: any }>(),
);
